import React, { useEffect, useState } from 'react'

import { DataContainer, Row } from 'Components/shared/Container'
import { H2 } from 'Components/shared/Typography'
import { Button } from 'Components/shared/Button'

import { CustomLinkTable } from './NewTable'
import Create from './CreateNew'

export default ({ club, customLinks, setCustomLinks }) => {
  const [showCreate, setShowCreate] = useState(false)
  const updateLinks = async () => {
    const links = customLinks.map(link => {
      const shortName = link.shortname || link.shortName
      const longName = link.longname || link.longName
      return {
        id: link.id,
        icon: link.icon,
        shortName: decodeURI(shortName)
          .replace(/[⁄]/gm, `/`)
          .replace(/&amp;frasl;|&frasl;/g, '/')
          .replace(/&amp;/g, '&'),
        longName: decodeURI(longName)
          .replace(/[⁄]/gm, `/`)
          .replace(/&amp;frasl;|&frasl;/g, '/')
          .replace(/&amp;/g, '&'),
        url: link.url
          .replace(/[⁄]/gm, `/`)
          .replace(/&amp;frasl;|&frasl;/g, '/')
          .replace(/&amp;/g, '&'),
        deleted: link.deleted === 0 || link.deleted === 'True' ? 'True' : 'False'
      }
    })
    setCustomLinks(links)
    setShowCreate(!showCreate)
  }
  useEffect(async () => {
    if (showCreate) updateLinks()
  }, [customLinks])

  return (
    <>
      <DataContainer>
        <Row style={{ margin: '10px' }}>
          <H2>Custom Links</H2>
        </Row>
        <Row style={{ margin: '10px' }}>
          {!showCreate && (
            <Button
              onClick={() => {
                setShowCreate(!showCreate)
              }}
            >
              Add New Custom Link
            </Button>
          )}
          {showCreate && (
            <Create selectedClub={club} updateLinks={setCustomLinks} links={customLinks} />
          )}
        </Row>
        <Row style={{ margin: '10px' }}>
          <CustomLinkTable
            customLinks={customLinks}
            setCustomLinks={setCustomLinks}
            updateLinks={updateLinks}
          />
        </Row>
      </DataContainer>
    </>
  )
}
